import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Row, Col, Button, Modal, ModalBody, ModalHeader, Table, Input } from 'reactstrap';
import { GET_SERVICE, GET_SERVICE_EMPTY, UPDATE_BOOKING } from '../../../../../../../../store/application/actionType';
import { Constant } from '../../../../../../../Helpers/constant';
import { isValidAplha, isValidNumber } from '../../../../../../../Helpers/Helpers';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';

const ConfirmModal = props => {
  const dispatch = useDispatch();
  /* ---------------------------- LOCAL STATES ---------------------------- */

  const [bookings, setBookings] = useState([]);

  const [modal_varying1, setmodal_varying1] = useState(true);

  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(true);

  useEffect(() => {
    validationCheck(bookings);
  }, [bookings]);

  useEffect(() => {
    if (props?.data !== null) {
      setBookings(
        props?.data.map(booking => {
          return {
            ...booking,
          };
        }),
      );
    }
  }, []);

  /* ---------------------------- INPUT CHANGE HANDLER ---------------------------- */
  const inputChangeHandler = (e, index) => {
    const { name, value } = e.target;

    let tempBooking = [...bookings];
    let selectedChangingBooking = tempBooking[index];

    switch (name) {
      case 'driverName':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          driver: {
            ...selectedChangingBooking?.driver,
            name: isValidAplha(value) ? value : selectedChangingBooking?.driver?.name,
          },
        };
        break;

      case 'driverMobile':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          driver: {
            ...selectedChangingBooking?.driver,
            mobile: isValidNumber(value) ? value : selectedChangingBooking?.driver?.mobile,
          },
        };
        break;

      case 'referenceNumber':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          referenceNumber: isValidNumber(value) ? value : selectedChangingBooking?.referenceNumber,
        };
        break;

      case 'pickupPoint':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          pickupLocation: {
            ...selectedChangingBooking?.pickupLocation,
            address: value,
          },
        };
        break;

      case 'engineerName':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          dropLocation: {
            ...selectedChangingBooking?.dropLocation,
            name: isValidAplha(value) ? value : selectedChangingBooking?.dropLocation?.name,
          },
        };
        break;

      case 'remarks':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          remarks: value,
        };
        break;

      default:
      // do nothing
    }
    tempBooking?.splice(index, 1, selectedChangingBooking);
    validationCheck(tempBooking);
    setBookings(tempBooking);
  };

  /* ---------------------------- DATE PICKER HANDLER ---------------------------- */
  const datePickHandler = (flag, date, index) => {
    let tempBooking = [...bookings];
    let selectedChangingBooking = tempBooking[index];
    const selectedTime = date[0]; // Extract the first (and only) date object from the array
    const value = selectedTime
      ? `${selectedTime.getHours().toString().padStart(2, '0')}:${selectedTime.getMinutes().toString().padStart(2, '0')}`
      : ''; // Extract hours and minutes as a string with leading zeros
    switch (flag) {
      case 'pickupDate':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          driver: {
            ...selectedChangingBooking?.driver,
            pickupDate: new Date(date).toISOString(),
          },
        };
        break;
      case 'pickupTime':
        selectedChangingBooking = {
          ...selectedChangingBooking,
          driver: {
            ...selectedChangingBooking?.driver,
            pickupTime: value,
          },
        };
        break;
      default:
      // do nothing
    }

    tempBooking?.splice(index, 1, selectedChangingBooking);
    validationCheck(tempBooking);
    setBookings(tempBooking);
  };

  /* ---------------------------- VALIDATION HANDLER ---------------------------- */
  const validationCheck = data => {
    let flag = false;

    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.driver?.name === '') {
        flag = true;
        break;
      } else if (data[i]?.driver?.mobile === '') {
        flag = true;
        break;
      } else if (data[i]?.driver?.pickupDate === '') {
        flag = true;
        break;
      } else if (data[i]?.driver?.pickupTime === '') {
        flag = true;
        break;
      } else if (data[i]?.dropLocation?.name === '') {
        flag = true;
        break;
      } else if (data[i]?.referenceNumber === '') {
        flag = true;
        break;
      } else if (data[i]?.remarks === '') {
        flag = true;
        break;
      }
    }

    flag ? setIsSubmitBtnDisabled(true) : setIsSubmitBtnDisabled(false);
  };

  /* ---------------------------- SUBMIT HANDLER ---------------------------- */
  const submitHandler = () => {
    const requestBookings = bookings?.map(booking => {
      const date = booking?.bookingDateTime?.split('T')[0];
      const tempBookingDateTime = `${date}T${booking?.tempTimeOfPlay}:00.000Z`;
      return {
        ...booking,
        objectId: booking?.bookingId,
        detailedBookingId: booking?.detailedBookingId,
        dateTimeOfService: {
          ...booking?.dateTimeOfService,
          time: booking?.dateTimeOfService?.time === '' ? '00:00' : booking?.dateTimeOfService?.time,
        },
        bookingDateTime: booking?.bookingDateTime?.replace('00Z', '00.000Z'),
        driver: {
          ...booking?.driver,
          pickupDate: `${moment(booking?.driver?.pickupDate).format('YYYY-MM-DD')}`,
        },
        status: Constant?.BOOKING_STATUS?.CONFIRM,
        process: `confirm-booking`,
      };
    });

    dispatch({
      type: UPDATE_BOOKING,
      payload: {
        data: {
          projectId: Constant?.CURRENT_SELECTED_PROGRAM?.id,
          bookingTypeId: Constant?.BOOKING_TYPES?.golfBookings?.objectId,
          bookingsData: requestBookings,
        },
      },
    });
    props.onCloseHandler(false);
    setmodal_varying1(!modal_varying1);
  };

  const tog_varying1 = () => {
    props.onCloseHandler(false);
    setmodal_varying1(!modal_varying1);
  };

  return (
    <Modal
      isOpen={modal_varying1}
      toggle={() => {
        tog_varying1();
      }}
      scrollable={true}
      id="exampleModal"
      size="lg"
    >
      <div className="modal-header p-3 bg-soft-secondary">
        <h5 className="modal-title" id="createboardModalLabel">
          Confirm Booking
        </h5>
        <Button
          type="button"
          onClick={() => {
            tog_varying1();
          }}
          id="addBoardBtn-close"
          className="btn-close btn-light"
          aria-label="Close"
        ></Button>
      </div>
      <ModalBody>
        {/* <button onClick={() => console.log(bookings)}>get state</button> */}
        <form>
          <Row>
            <Col md={12} style={{ mixHeight: '500px' }}>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Booking ID</th>
                    <th> Name</th>
                    <th> Picker Name</th>
                    <th> Picker Mobile</th>
                    <th> Driver Pickup Date</th>
                    <th> Driver Pickup Time</th>
                    <th> Name of Assigned Service Engineer</th>
                    <th> Reference No</th>
                    <th> Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings?.map((booking, index) => (
                    <tr key={index}>
                      <th>{index + 1}.</th>
                      <td>{booking?.bookingId}</td>
                      <td>{booking?.user?.name}</td>
                      <td>
                        <Input
                          id="driverName"
                          name="driverName"
                          type="text"
                          placeholder=""
                          style={{ width: '200px' }}
                          className="form-control"
                          onChange={e => inputChangeHandler(e, index)}
                          value={booking?.driver?.name}
                        />
                      </td>
                      <td>
                        <Input
                          id="driverMobile"
                          name="driverMobile"
                          type="number"
                          onWheel={e => e.target.blur()}
                          placeholder=""
                          style={{ width: '200px' }}
                          className="form-control"
                          onChange={e => inputChangeHandler(e, index)}
                          value={booking?.driver?.mobile}
                        />
                      </td>
                      <td>
                        <Flatpickr
                          className="form-control"
                          name="booking-date-time"
                          id="booking-date-time"
                          value={booking.driver?.pickupDate}
                          onChange={date => datePickHandler(`pickupDate`, date, index)}
                          options={{
                            minDate: 'today',
                            enableTime: false,
                            dateFormat: 'Y-m-d ',
                          }}
                          style={{ width: '200px' }}
                        />
                      </td>
                      <td>
                        <Flatpickr
                          className={`form-control`}
                          name={`pickupTime`}
                          id="pickupTime"
                          value={booking?.driver?.pickupTime}
                          style={{ width: '60px' }}
                          onChange={date => datePickHandler(`pickupTime`, date, index)}
                          options={{
                            // minDate: 'today',
                            noCalendar: true,
                            enableTime: true,
                            dateFormat: 'H:i',
                            time_24hr: false,
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          id="engineerName"
                          name="engineerName"
                          type="text"
                          placeholder=""
                          className="form-control"
                          onChange={e => inputChangeHandler(e, index)}
                          value={booking?.dropLocation?.name}
                          style={{ width: '200px' }}
                        />
                      </td>
                      <td>
                        <Input
                          id="referenceNumber"
                          name="referenceNumber"
                          type="number"
                          onWheel={e => e.target.blur()}
                          placeholder=""
                          className="form-control"
                          onChange={e => inputChangeHandler(e, index)}
                          value={booking?.referenceNumber}
                          style={{ width: '200px' }}
                        />
                      </td>
                      <td>
                        <Input
                          id="remarks"
                          name="remarks"
                          type="textarea"
                          placeholder=""
                          className="form-control"
                          onChange={e => inputChangeHandler(e, index)}
                          value={booking?.remarks}
                          style={{ width: '200px' }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </form>
      </ModalBody>
      <div className="modal-footer d-flex justify-content-center">
        <Button className="overlay-disable" color="primary" onClick={submitHandler} disabled={isSubmitBtnDisabled}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
